import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('components.ProfileEditPopup.SectionCertification', {
    title: 'Certification',
    description: 'You have passed ApprovalMax Certification',
    buttonDownload: 'Download',
});
